import { TablePreferences } from "@/components/chat/types";

/**
 * Rows an admin table shows per page before the user changes it.
 *
 * Admin-only on purpose. The chat and cart clip tables share
 * `DEFAULT_PREFERENCES` in `utils/constants.ts` and must stay at 50 rows; keeping
 * the admin number in its own module means raising it cannot reach them.
 */
export const ADMIN_DEFAULT_PAGE_SIZE = 100;

/**
 * Selectable page sizes offered by every admin table's preferences gear.
 *
 * A superset of every list these tables offered before — Cached Messages
 * 10/25/50, Metadata Configuration and the Eval Dataset 25/50/100 — so no user
 * loses an option they have today.
 */
export const ADMIN_PAGE_SIZE_OPTIONS = [10, 25, 50, ADMIN_DEFAULT_PAGE_SIZE] as const;

/** Initial preferences for an admin table that also offers striped rows. */
export const ADMIN_TABLE_PREFERENCES: TablePreferences = {
  pageSize: ADMIN_DEFAULT_PAGE_SIZE,
  stripedRows: true,
};

/**
 * `pageSizePreference` for a Cloudscape `CollectionPreferences`.
 *
 * @param unit noun for the rows of this table ("items", "fields", "cases")
 */
export const adminPageSizePreference = (unit = "items") => ({
  title: "Page size",
  options: ADMIN_PAGE_SIZE_OPTIONS.map((value) => ({
    value,
    label: `${value} ${unit}`,
  })),
});
